/*
  Date-of-birth selects.

  The options are rendered by Liquid, so the field works without this file. All
  this does is keep the day list honest for the chosen month and compose the
  three values into one ISO date on the hidden input.
*/
(function () {
  'use strict';

  function daysInMonth(month, year) {
    // Day 0 of the next month is the last day of this one, and it accounts for
    // leap years without a special case.
    if (!month) return 31;
    if (!year) return month === 2 ? 29 : new Date(2000, month, 0).getDate();
    return new Date(year, month, 0).getDate();
  }

  function setup(root) {
    if (root.dobReady) return;
    root.dobReady = true;

    var day = root.querySelector('[data-dob-day]');
    var month = root.querySelector('[data-dob-month]');
    var year = root.querySelector('[data-dob-year]');
    var value = root.querySelector('[data-dob-value]');
    if (!day || !month || !year || !value) return;

    function trimDays() {
      var max = daysInMonth(parseInt(month.value, 10), parseInt(year.value, 10));
      var chosen = parseInt(day.value, 10);

      Array.prototype.forEach.call(day.options, function (option) {
        if (!option.value) return;
        var n = parseInt(option.value, 10);
        option.hidden = n > max;
        option.disabled = n > max;
      });

      // 31 selected, then February chosen: clear it rather than submit a date
      // that does not exist.
      if (chosen && chosen > max) day.value = '';
    }

    function compose() {
      var d = day.value;
      var m = month.value;
      var y = year.value;

      if (!d || !m || !y) {
        value.value = '';
      } else {
        value.value = y + '-' + String(m).padStart(2, '0') + '-' + String(d).padStart(2, '0');
      }

      // So anything listening to the hidden input (validation, analytics) sees it.
      value.dispatchEvent(new Event('change', { bubbles: true }));
      root.classList.toggle('dob--filled', !!value.value);
    }

    [day, month, year].forEach(function (select) {
      select.addEventListener('change', function () {
        trimDays();
        compose();
      });
    });

    trimDays();
    compose();
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-dob]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  // The rewards and early-access drawers inject their forms after load.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (node.matches && node.matches('[data-dob]')) setup(node);
        if (node.querySelectorAll) scan(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
